import logo_cropped_img from "../../assets/images/logo/LogoCropped.png";
import full_logo from "../../assets/svgs/FullLogo.svg";
import logo_cropped from "../../assets/svgs/LogoCropped.svg";

export const LOGO_CROPPED = logo_cropped;
export const LOGO_CROPPED_IMG = logo_cropped_img;
export const FULL_LOGO = full_logo;

export default [LOGO_CROPPED_IMG];
